import { render, staticRenderFns } from "./formPage.vue?vue&type=template&id=5d639561&scoped=true"
import script from "./formPage.vue?vue&type=script&lang=js"
export * from "./formPage.vue?vue&type=script&lang=js"
import style0 from "./formPage.vue?vue&type=style&index=0&id=5d639561&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d639561",
  null
  
)

export default component.exports